import React from 'react';
import type { IconProps } from './types';

// AI "sparkles" glyph — a large four-point star with two smaller companions.
const SparkleIcon: React.FC<IconProps> = ({ size = 26, color = '#fff', ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M12 2.5c.35 3.4 1.6 4.65 5 5-3.4.35-4.65 1.6-5 5-.35-3.4-1.6-4.65-5-5 3.4-.35 4.65-1.6 5-5Z"
      fill={color}
    />
    <path
      d="M18.5 13c.2 1.7.85 2.35 2.5 2.5-1.65.2-2.3.85-2.5 2.5-.2-1.65-.85-2.3-2.5-2.5 1.65-.15 2.3-.8 2.5-2.5Z"
      fill={color}
    />
    <path
      d="M6 14c.18 1.55.77 2.13 2.25 2.25C6.77 16.42 6.18 17 6 18.5c-.18-1.5-.77-2.08-2.25-2.25C5.23 16.13 5.82 15.55 6 14Z"
      fill={color}
    />
  </svg>
);

export default SparkleIcon;
